"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "@/lib/hooks/useTranslation";
export function RecaptchaLegalNotice() {
  const $ = _c(8);
  const {
    locale
  } = useTranslation();
  const fr = locale === "fr";
  const t0 = fr ? "Prot\xE9g\xE9 par reCAPTCHA \u2014 " : "Protected by reCAPTCHA \u2014 ";
  const t1 = fr ? "Confidentialit\xE9" : "Privacy";
  let t2;
  if ($[0] !== t1) {
    t2 = <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="underline hover:text-foreground/70">{t1}</a>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = fr ? "Conditions" : "Terms";
  let t4;
  if ($[2] !== t3) {
    t4 = <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-foreground/70">{t3}</a>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t0 || $[5] !== t2 || $[6] !== t4) {
    t5 = <p className="text-[10px] leading-tight text-muted-foreground/70">{t0}{t2}{" \xB7 "}{t4}</p>;
    $[4] = t0;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}